import { Switch, Route, useRouteMatch } from "react-router-dom";
import {
    ListCategoryScreen,
    CreateCategoryScreen,
    ShowCategoryScreen,
    UpdateCategoryScreen,
    DeleteCategoryScreen,
} from "../screens";
import routes from "./URL";
export default function gallery_image_routes() {
    return (
        <Switch>
              <Route
                exact
                path={routes.admin.category.root(":hotelSlug")}
                component={ListCategoryScreen}
            />
            <Route
                path={routes.admin.category.create(":hotelSlug")}
                component={CreateCategoryScreen}
            />
            <Route
                path={routes.admin.category.update(":hotelSlug",":slug",":id")}
                component={UpdateCategoryScreen}
            
            />
            <Route
                path={routes.admin.category.show( ":hotelSlug",":slug",":id")}
                component={ShowCategoryScreen}
            />
          
            {/* <Route exact path={"/"} component={ListGalleryScreen} /> */}
        </Switch>
    );
}
